import React from 'react'
import AssignProductToRestaurantContainer from '../../../../Components/ProductRegisterPart/AssignProductToRestaurantContainer/AssignProductToRestaurantContainer'
import Layout from '../../Layout'

const AssignProductToRestaurant = () => {
  return (
    <Layout>
      <AssignProductToRestaurantContainer/>
    </Layout>
  )
}

export default AssignProductToRestaurant